function MomentFilter() {
  return function (momentDate, format) {
    if (!momentDate || !momentDate.format || !format) return momentDate;
    return momentDate.format(format);
  };
}

MomentFilter.$inject = [];

export default MomentFilter;



// WEBPACK FOOTER //
// ./src/filters/momentFilter.js